export class WorkUserEvent {
    workId: string;
    id: string;
    login: string;
    name: string;
    email: string;
    error ?: string;
}
